import { onboarding } from '@services';

interface IRequest {
  studioId: string;
}

export interface IGetFilesCount {
  open: number;
  closed: number;
}

const getFilesCount = async ({
  studioId,
}: IRequest): Promise<IGetFilesCount> => {
  const { data } = await onboarding.get<IGetFilesCount>(
    `/api/v1/file/count?studioId=${studioId}`,
  );

  return data;
};

export { getFilesCount };
